export default __webpack_public_path__ + "static/media/bkg--home-1.db99c878.jpg";